import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { message: String }
  }

  open() {
    Intercom('showNewMessage', this.messageValue)
  }
}
